const permissionConfig = [
  {
    role: "SuperAdmin",
    show: ["Settings", "Work List", "Marketing", "Blog Categories", "Blog Posts","Subscription"],
    // SuperAdmin can access all paths
    allowedPaths: [],
  },
  {
    role: "Client",
    show: ["Onboarding"],
    allowedPaths: ["/onboarding"],
  },
  {
    role: "Admin",
    show: ["Onboarding"],
    allowedPaths: ["/onboarding"],
  },
  {
    role: "Customer",
    show: [],
    allowedPaths: [],
  },
];

export default permissionConfig;
